<div>
  <p-toolbar>
    <div class="p-toolbar-group-left">
      <button pButton type="button" icon="pi pi-plus"
              (click)="openDlgUserRecord(true)" pTooltip="Add new user"></button>
      <button pButton type="button" icon="pi pi-pencil"
              [disabled]="selected == null" (click)="openDlgUserRecord(false, selected)" pTooltip="Edit the user"></button>
      <button pButton type="button" icon="pi pi-trash"
              [disabled]="selected == null" (click)="delete()" pTooltip="Remove the user"></button>
      <button pButton type="button" icon="pi pi-envelope"
              [disabled]="!selected?.keycloakId" (click)="sendVerifyEmail()"
              pTooltip="Send an email-verification email"></button>
      <button pButton type="button" icon="pi pi-sync"
              [disabled]="loading" (click)="updateActivationDates()"
              pTooltip="Update user activation dates"></button>

      <i class="p-toolbar-separator pi pi-bars" style="vertical-align: middle"></i>

      <p-splitButton icon="far fa-list-alt"
                     [disabled]="selected == null" [model]="menu"
                     iconPos="left" pTooltip="View logs"></p-splitButton>
    </div>
  </p-toolbar>

  <p-table #dt
           [value]="users.content"
           [totalRecords]="users.totalElements" [rows]="users.size"
           [lazy]="true" (onLazyLoad)="handlePageChange($event)" [loading]="loading"
           (onRowSelect)="handleRowSelect($event)" selectionMode="single" [(selection)]="selected"
           [paginator]="true" paginatorPosition="bottom"
           [resizableColumns]="true"
           [scrollable]="true" [scrollHeight]="'calc(100vh - 250px)'"
           sortField="username" [sortOrder]="1">
    <ng-template pTemplate="colgroup">
      <colgroup>
        <col style="width: 2.5rem;">
        <col/>
        <col/>
        <col/>
        <col/>
        <col/>
        <col/>
        <col/>
        <col/>
      </colgroup>
    </ng-template>
    <ng-template pTemplate="header">
      <tr>
        <th></th>
        <th pSortableColumn="email">e-Mail
          <p-sortIcon field="email"></p-sortIcon>
        </th>
        <th pSortableColumn="fullname">Full Name
          <p-sortIcon field="fullname"></p-sortIcon>
        </th>
        <th>Admin</th>
        <th>Country</th>
        <th>City</th>
        <th pSortableColumn="lastLogon">Last Login
          <p-sortIcon field="lastLogon"></p-sortIcon>
        </th>
        <th pSortableColumn="keycloakActivationDate">Activation date
          <p-sortIcon field="keycloakActivationDate"></p-sortIcon>
        </th>
        <th pSortableColumn="keycloakEmailDate">Activation link expiration date
          <p-sortIcon field="keycloakEmailDate"></p-sortIcon>
        </th>
      </tr>
      <tr>
        <th></th>
        <th>
          <input pInputText type="text" [style.width]="'99%'"
                 (change)="dt.filter($event.target.value, 'email', 'contains')"/>
        </th>
        <th>
          <input pInputText type="text" [style.width]="'99%'"
                 (change)="dt.filter($event.target.value, 'fullname', 'contains')"/>
        </th>
        <th>
          <p-dropdown appendTo="body" [options]="types" [style]="{ 'max-width':'99%', 'min-width': '99%' }"
                      (onChange)="dt.filter($event.value, 'typeAdmin', 'eq')"></p-dropdown>
        </th>
        <th>
          <input pInputText type="text" [style.width]="'99%'"
                 (change)="dt.filter($event.target.value, 'country', 'contains')"/>
        </th>
        <th>
          <input pInputText type="text" [style.width]="'99%'"
                 (change)="dt.filter($event.target.value, 'city', 'contains')"/>
        </th>
        <th></th>
        <th></th>
        <th></th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-row let-i="rowIndex">
      <tr [pSelectableRow]="row" (dblclick)="handleDblRowClick($event, row)"
          [class.table-row-gray]="row.accountLocked">
        <td [pTooltip]="(row.accountLocked ? 'Non-Active' : 'Active') + '\n' + (row.lastLogon || '')">
          <i class="far fa-check-circle" style="color: green!important;" *ngIf="!row.accountLocked"></i>
          <i class="far fa-question-circle" *ngIf="row.accountLocked"></i>
        </td>
        <td>{{ row.email }}</td>
        <td>{{ row.fullname }}</td>
        <td>{{ row.typeAdmin == 1 ? 'System administrator' : (row.typeAdmin === 4 ? 'API User' : 'None') }}</td>
        <td>{{ row.country }}</td>
        <td>{{ row.city }}</td>
        <td>{{ row.lastLogon }}</td>
        <td>{{ row.keycloakActivationDate }}</td>
        <td>{{ row.keycloakEmailDate }}</td>
      </tr>
    </ng-template>
    <ng-template pTemplate="paginatorleft">
      <div class="text-left" *ngIf="configService.isDesktopDevice">
        {{ 'Total records ' + users.totalElements }}
      </div>
    </ng-template>
  </p-table>

  <p-dialog
    [header]="'User access (' + (currentUser?.fullname) + ')'"
    [(visible)]="showDlgListProjects"
    [modal]="true" [style]="{width: '1100px', minWidth: '1000px'}"
    [maximizable]="false">
    <app-admin-listUserProjects></app-admin-listUserProjects>
    <ng-template pTemplate="footer">
      <div>
        <button pButton type="button" icon="pi pi-times"
                (click)="showDlgListProjects=false"
                label="Close"></button>
      </div>
    </ng-template>
  </p-dialog>

  <p-dialog header="View Logs" [(visible)]="showDlgLogs"
            [modal]="true" [style]="{width: '1100px', minWidth: '1100px'}"
            [maximizable]="true" [resizable]="true" [baseZIndex]="10000">
    <div [ngSwitch]="showDlgLogsType">
      <ng-template [ngSwitchCase]="1">
        <app-adminlog-connects [idUser]="this.selected && this.selected.id"></app-adminlog-connects>
      </ng-template>
      <ng-template [ngSwitchCase]="2">
        <app-adminlog-private [idUser]="this.selected && this.selected.id"></app-adminlog-private>
      </ng-template>
    </div>
  </p-dialog>

  <app-admin-user-edit [value]="currentUser" [mode]="editMode" [(visible)]="showDlgUserRecord"
                       (saved)="save($event)" (showProjects)="openDlgListProjects()"
                       [loading]="loading"></app-admin-user-edit>

  <!--Confirm dialog-->
  <p-confirmDialog></p-confirmDialog>
</div>
